import { render, staticRenderFns } from "./DebtsCalendar.vue?vue&type=template&id=ca4ffd18&scoped=true&lang=pug&"
import script from "./DebtsCalendar.vue?vue&type=script&lang=js&"
export * from "./DebtsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DebtsCalendar.vue?vue&type=style&index=0&id=ca4ffd18&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4ffd18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca4ffd18')) {
      api.createRecord('ca4ffd18', component.options)
    } else {
      api.reload('ca4ffd18', component.options)
    }
    module.hot.accept("./DebtsCalendar.vue?vue&type=template&id=ca4ffd18&scoped=true&lang=pug&", function () {
      api.rerender('ca4ffd18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/DebtsCalendar.vue"
export default component.exports